/**
 * MODULE: platform/browser/frontend/utils/browserChatHydration.ts
 * PURPOSE: Map server-side action audit entries to chat messages.
 */

import type { ChatMessage } from '../types/browser.types';
import { classifyAssistantOutcome } from './browserAssistantOutcome';
import { formatBrowserActError } from './formatBrowserError';

export interface BrowserSessionActionLogEntry {
  eventType: string;
  message: string;
  timestamp: string;
}

function roleForEventType(eventType: string): ChatMessage['role'] {
  if (eventType === 'user') return 'user';
  if (eventType === 'done') return 'assistant';
  if (eventType === 'error') return 'error';
  return 'action';
}

export function serverActionsToChatMessages(entries: BrowserSessionActionLogEntry[]): ChatMessage[] {
  return entries
    .filter((e) => e.message.trim() || e.eventType === 'user')
    .map((entry, index) => ({
      id: `audit-${entry.timestamp}-${index}`,
      role: roleForEventType(entry.eventType),
      content:
        entry.eventType === 'error'
          ? formatBrowserActError(entry.message)
          : entry.message,
      actionType: entry.eventType as ChatMessage['actionType'],
      outcome:
        entry.eventType === 'done' ? classifyAssistantOutcome(entry.message) : undefined,
      timestamp: entry.timestamp || undefined,
    }));
}
